import React from 'react';
import { List, Datagrid, TextField, DateField, EditButton, BooleanField, ArrayField, SingleFieldList, ChipField } from 'react-admin';
import { DatagridSX, ListSX } from '../../../styled/custom';
import CustomFilterDefault from '../../../filter/custom-filter-default';
import CustomListDefaultToolbar from '../../../ui/custom-list-default-toolbar';
import DaysGroupExporter from '../../../exporter/days-group-exporter';

const DaysGroupList = (props) => (
  <List
    title="Grupos de Dias"
    sort={{ field: 'id', order: 'desc' }}
    filters={ CustomFilterDefault }
    exporter={ DaysGroupExporter }
    actions={ <CustomListDefaultToolbar /> }
    sx={ListSX}>
    <Datagrid
      rowClick="show"
      bulkActionButtons={false}
      sx={DatagridSX}>
      <TextField source="id" sortable={false} />
      <TextField source="name" label="Nome" sortable={false} />
      <ArrayField label="Dias" source="days" sortable={false}>
        <SingleFieldList linkType={false}>
          <ChipField source="name" />
        </SingleFieldList>
      </ArrayField>
      <BooleanField source="active" label="Ativo" sortable={false} />
      <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} showTime />
      <EditButton />
    </Datagrid>
  </List>
);

export default DaysGroupList;
